import { useUI } from '@components/ui'
import cn from 'clsx'
import { useTranslation } from 'next-i18next'
interface Props {
  classname?: string
  prismicContent?: any
}
const GardenPotModalButton = ({ classname, prismicContent }: Props) => {
  const { t } = useTranslation('common')
  const { setModalView, openModal, setSidebarView, openSidebar } = useUI()
  const { gardenPotPaintModalButtonText } = prismicContent || undefined
  const showPaintSelectionModal = () => {
    setSidebarView('GARDEN_POT_MODAL_VIEW')
    openSidebar()
  }
  return (
    <>
      <button
        className={cn(
          'label-bold flex items-center justify-between outline-none focus:outline-none',
          {
            classname,
          }
        )}
        aria-label={`${t('garden-pot-paint')} Modal`}
        onClick={showPaintSelectionModal}
      >
        {gardenPotPaintModalButtonText && (
          <div className="body-2 text-decoration-line: mr-1 text-brand-dark-grey underline">
            {gardenPotPaintModalButtonText}
          </div>
        )}
      </button>
    </>
  )
}
export default GardenPotModalButton
